import { combineReducers } from '@reduxjs/toolkit';
import { createCustomSlice } from '../store.utils';
import {
  getTagsListAsyncThunk,
  createTagAsyncThunk,
  updateTagAsyncThunk,
  deleteTagAsyncThunk,
  toggleTagActiveAsyncThunk,
} from './tags.action';

// ---------- LIST ----------
const tagsListSlice = createCustomSlice('tags/tagsList', getTagsListAsyncThunk);

// ---------- CREATE ----------
const tagCreateSlice = createCustomSlice('tags/createTag', createTagAsyncThunk);

// ---------- UPDATE ----------
const tagUpdateSlice = createCustomSlice('tags/updateTag', updateTagAsyncThunk);

// ---------- DELETE ----------
const tagDeleteSlice = createCustomSlice('tags/deleteTag', deleteTagAsyncThunk);

// ---------- TOGGLE ACTIVE ----------
const tagToggleActiveSlice = createCustomSlice(
  'tags/toggleTagActive',
  toggleTagActiveAsyncThunk
);

export const { reset: resetTagsList } = tagsListSlice.actions;
export const { reset: resetTagCreate } = tagCreateSlice.actions;
export const { reset: resetTagUpdate } = tagUpdateSlice.actions;
export const { reset: resetTagDelete } = tagDeleteSlice.actions;
export const { reset: resetTagToggleActive } = tagToggleActiveSlice.actions;

// ---------- COMBINED REDUCER ----------
export const tagsReducer = combineReducers({
  tagsList: tagsListSlice.reducer,
  createTag: tagCreateSlice.reducer,
  updateTag: tagUpdateSlice.reducer,
  deleteTag: tagDeleteSlice.reducer,
  toggleTagActive: tagToggleActiveSlice.reducer,
});
